import { bannerStyles } from "@insite/content-library/Widgets/Category/CategoryDetailBanner";
import { css } from "styled-components";

bannerStyles.container = {
    css: css`
    div{
        div{
            font-size: 1rem;
            line-height: 25px;
            font-weight: 400;
        }
    }
    `
}